import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import truncate from "truncate-html";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function DetailsSection({
  datacontent = [],
  downloadSection = [],
  sideNewSection = [],
  advertSection = [],
  initialPagination,
  initialPaginationDownload,
  datacontentDataSearch,
}) {
  const [currentPage, setCurrentPage] = useState(1);

  const [downloadList, setDownloadList] = useState(downloadSection || []);
  const [selectedDownload, setSelectedDownload] = useState(
    downloadSection?.[0] || null,
  );

  const [newsList, setNewsList] = useState(datacontent || []);
  const [selectedNews, setSelectedNews] = useState(datacontent?.[0] || null);

  const [page, setPage] = useState(1);
  const [pageDownload, setPageDownload] = useState(1);

  const [pagination, setPagination] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
    },
  );

  const [paginationDownload, setPaginationDownload] = useState(
    initialPaginationDownload || {
      current_page: 1,
      last_page: 1,
    },
  );

  const [loading, setLoading] = useState(false);

  // MAIN READ DATA
  const currentRead = Array.isArray(newsList) ? newsList : [];

  // SIDE NEWS
  const dataArray = Array.isArray(sideNewSection) ? sideNewSection : [];

  // DOWNLOADS
  const dataDownloadArray = Array.isArray(downloadList) ? downloadList : [];

  // RANDOM SIDE NEWS
  useEffect(() => {
    if (dataArray.length > 0) {
      const maxPage = Math.min(dataArray.length, 5);

      const randomStartPage = Math.floor(Math.random() * maxPage);

      setCurrentPage(randomStartPage);
    }
  }, [dataArray.length]);

  // INITIALIZE DOWNLOADS
  useEffect(() => {
    setDownloadList(downloadSection || []);
    setNewsList(datacontent || []);

    setSelectedDownload(downloadSection?.[0] || null);
    setSelectedNews(datacontent?.[0] || null);
  }, [downloadSection, datacontent]);

  // FETCH DOWNLOADS
  useEffect(() => {
    if (page > 1 || pageDownload > 1) {
      fetchNews();
    }
  }, [page, pageDownload]);

  const fetchNews = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}read-data`, {
        params: {
          id: datacontentDataSearch.value,
          read_page: page,
          download_page: pageDownload,
        },
      });

      const readSection = response?.data?.data?.readSection?.data || [];
      const downloadSection = response?.data?.data?.downloadSection?.data || [];

      setDownloadList(downloadSection);
      setNewsList(readSection);

      setPagination(
        response?.data?.data?.readSection?.pagination || {
          current_page: 1,
          last_page: 1,
        },
      );

      setPaginationDownload(
        response?.data?.data?.downloadSection?.pagination || {
          current_page: 1,
          last_page: 1,
        },
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // HELPERS
  function getRandomWholeNumber(max) {
    return Math.ceil(Math.random() * max);
  }

  const TruncateHtml = (htmlString, length) => {
    return truncate(htmlString, length, {
      byWords: true,
    });
  };

  // PAGINATION
  const changePage = (newPage) => {
    if (pagination && newPage >= 1 && newPage <= pagination.last_page) {
      const scrollPosition = window.scrollY;

      setPage(newPage);

      setTimeout(() => {
        window.scrollTo({
          top: scrollPosition,
          behavior: "instant",
        });
      }, 50);
    }
  };

  const changePageDownload = (newPage) => {
    if (
      paginationDownload &&
      newPage >= 1 &&
      newPage <= paginationDownload.last_page
    ) {
      const scrollPosition = window.scrollY;

      setPageDownload(newPage);

      setTimeout(() => {
        window.scrollTo({
          top: scrollPosition,
          behavior: "instant",
        });
      }, 50);
    }
  };

  // NO DATA
  if (!currentRead) return null;

  // DATE
  const currentItem = currentRead[0] || {};

  const date = new Date(currentItem.daterqw);

  const month = date
    .toLocaleString("default", {
      month: "short",
    })
    .toUpperCase();

  const day = date.getDate();

  const year = date.getFullYear();

  // ALIGNMENT
  const alignment = currentRead?.aligment009?.toLowerCase() || "center";

  // GET THE 10 MOST RECENT
  const recentUpdates = [...dataArray]
    .sort((a, b) => new Date(b.daterqw) - new Date(a.daterqw))
    .slice(0, 10);

  // RANDOMIZE THEM
  const shuffledUpdates = [...recentUpdates].sort(() => Math.random() - 0.5);

  // TAKE ONLY 2 OR 3 RANDOM ITEMS
  const randomUpdates = shuffledUpdates.slice(0, 2);

  return (
    <section id="service-details" className="service-details section">
      <div className="container">
        <div className="row gy-4">
          {/* MAIN CONTENT */}
          <div
            className={alignment === "center" ? "col-lg-8" : "col-lg-12"}
            data-aos="fade-up"
            data-aos-delay={200}
          >
            <div className="mb-4">
              {/* LEFT / RIGHT */}
              {(alignment === "left" || alignment === "right") && (
                <div className="mb-4">
                  {currentRead.map((latestNew, i) => (
                    <>
                      {latestNew.passport &&
                        latestNew.passport !== "undefined" &&
                        latestNew.passport !== "null" &&
                        latestNew.passport.trim() !== "" && (
                          <img
                            loading="lazy"
                            decoding="async"
                            src={`${BACKEND_URL}upload/${latestNew.passport}`}
                            alt={latestNew.title || "Image"}
                            className={`wrapped-image ${
                              alignment === "right"
                                ? "float-end ms-4"
                                : "float-start me-4"
                            }`}
                          />
                        )}

                      <div className="vertical-date-badge ms-2">
                        <div className="date-part">{month}</div>

                        <div className="date-divider">—</div>

                        <div className="date-part vertical-formatDate">
                          {day}
                        </div>

                        <div className="date-divider">—</div>

                        <div className="date-part">{year}</div>
                      </div>

                      {latestNew.caption && (
                        <small className="text-muted">
                          <em>
                            <HTMLDisplay
                              html={latestNew.caption}
                              type="title"
                            />
                          </em>
                        </small>
                      )}

                      <span className="text-secondary pt-2">
                        <HTMLDisplay html={latestNew.story01} type="title" />
                      </span>

                      <p className="text-secondary">
                        <HTMLDisplay html={latestNew.story01} type="body" />
                      </p>

                      <div className="clearfix"></div>
                    </>
                  ))}
                </div>
              )}

              {/* CENTER */}
              {alignment === "center" && (
                <>
                  {currentRead.map((latestNew, i) => (
                    <>
                      {latestNew.passport &&
                        latestNew.passport !== "undefined" &&
                        latestNew.passport !== "null" &&
                        latestNew.passport.trim() !== "" && (
                          <img
                            loading="lazy"
                            decoding="async"
                            src={`${BACKEND_URL}upload/${latestNew.passport}`}
                            alt={latestNew.title || "Image"}
                            className="img-fluid w-100 mb-3"
                            style={{
                              objectFit: "cover",
                            }}
                          />
                        )}

                      <div className="vertical-date-badge ms-2">
                        <div className="date-part">{month}</div>

                        <div className="date-divider">—</div>

                        <div className="date-part vertical-formatDate">
                          {day}
                        </div>

                        <div className="date-divider">—</div>

                        <div className="date-part">{year}</div>
                      </div>

                      {latestNew.caption && (
                        <small className="text-muted">
                          <em>
                            <HTMLDisplay
                              html={latestNew.caption}
                              type="title"
                            />
                          </em>
                        </small>
                      )}

                      <span className="text-secondary pt-2">
                        <HTMLDisplay html={latestNew.story01} type="title" />
                      </span>

                      <p className="text-secondary">
                        <HTMLDisplay html={latestNew.story01} type="body" />
                      </p>
                    </>
                  ))}
                </>
              )}
              {/* PAGINATION */}
              <div className="d-flex justify-content-end align-items-center mt-3">
                <button
                  className="btn btn-dark me-2"
                  onClick={() => changePage(1)}
                  disabled={pagination?.current_page === 1}
                >
                  «
                </button>

                <button
                  className="btn btn-dark me-2"
                  onClick={() => changePage(pagination?.current_page - 1)}
                  disabled={pagination?.current_page === 1}
                >
                  ‹
                </button>

                <span className="me-2">
                  Page {pagination?.current_page} of {pagination?.last_page}
                </span>

                <button
                  className="btn btn-dark me-2"
                  onClick={() => changePage(pagination?.current_page + 1)}
                  disabled={pagination?.current_page === pagination?.last_page}
                >
                  ›
                </button>

                <button
                  className="btn btn-dark"
                  onClick={() => changePage(pagination?.last_page)}
                  disabled={pagination?.current_page === pagination?.last_page}
                >
                  »
                </button>
              </div>
            </div>
          </div>

          {/* SIDEBAR */}
          {alignment === "center" && (
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay={100}>
              {/* MORE UPDATE */}
              {dataArray.length > 0 && (
                <div className="highlight-box mb-4">
                  {randomUpdates.map((service, index) => {
                    const sideDate = new Date(service.daterqw);

                    const sideMonth = sideDate
                      .toLocaleString("default", {
                        month: "short",
                      })
                      .toUpperCase();

                    const sideDay = sideDate.getDate();

                    const sideYear = sideDate.getFullYear();

                    return (
                      <div key={service.id || index} className="mb-4">
                        <div className="highlight-title">MORE UPDATE</div>
                        {service.passport &&
                          service.passport !== "undefined" &&
                          service.passport !== "null" &&
                          service.passport.trim() !== "" && (
                            <img
                              loading="lazy"
                              decoding="async"
                              src={`${BACKEND_URL}upload/${service.passport}`}
                              alt={service.title || "Image"}
                              className="img-fluid rounded mb-2"
                              style={{
                                height: "200px",
                                objectFit: "cover",
                                width: "100%",
                              }}
                            />
                          )}

                        <div className="vertical-date-badge ms-0 mt-5">
                          <div className="date-part">{sideMonth}</div>

                          <div className="date-divider">—</div>

                          <div className="date-part vertical-formatDate">
                            {sideDay}
                          </div>

                          <div className="date-divider">—</div>

                          <div className="date-part">{sideYear}</div>
                        </div>

                        <span className="text-secondary">
                          <HTMLDisplay html={service.story01} type="title" />
                        </span>

                        <p className="text-secondary">
                          <HTMLDisplay
                            html={service.story01}
                            textNo={30}
                            type="body"
                          />
                        </p>

                        <div className="text-end">
                          <Link
                            to={`/read/${service.id}`}
                            className="btn btn-iceberg"
                          >
                            Read More →
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* ADVERT */}
              {advertSection.length > 0 && (
                <div className="highlight-box mb-4">
                  <div className="highlight-title">AWARENESS ZONE</div>

                  {advertSection[getRandomWholeNumber(advertSection.length) - 1]
                    ?.passport && (
                    <img
                      loading="lazy"
                      decoding="async"
                      src={`${BACKEND_URL}upload/${
                        advertSection[
                          getRandomWholeNumber(advertSection.length) - 1
                        ]?.passport
                      }`}
                      alt="Ad"
                      className="img-fluid rounded"
                    />
                  )}
                </div>
              )}

              {/* DOWNLOADS */}
              <div className="highlight-box mb-4 portfolio-info">
                <div className="highlight-title">Downloadable Resources</div>

                <ul className="list-unstyled">
                  {dataDownloadArray.map((file, i) => (
                    <li
                      key={i}
                      className="d-flex align-items-center justify-content-between gap-2 mb-2"
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="fas fa-file-pdf fs-5 text-danger"></i>

                        <Link
                          to={`${BACKEND_URL}upload/${file.addressLink}`}
                          download
                          className="text-capitalize text-decoration-none"
                        >
                          {TruncateHtml(file.title, 12)}
                        </Link>
                      </div>

                      <i className="fas fa-download fs-5"></i>
                    </li>
                  ))}
                </ul>

                {/* DOWNLOAD PAGINATION */}
                <div className="d-flex justify-content-end align-items-center mt-3">
                  <button
                    className="btn btn-dark me-2"
                    onClick={() => changePageDownload(1)}
                    disabled={paginationDownload?.current_page === 1}
                  >
                    «
                  </button>

                  <button
                    className="btn btn-dark me-2"
                    onClick={() =>
                      changePageDownload(paginationDownload?.current_page - 1)
                    }
                    disabled={paginationDownload?.current_page === 1}
                  >
                    ‹
                  </button>

                  <span className="me-2">
                    Page {paginationDownload?.current_page} of{" "}
                    {paginationDownload?.last_page}
                  </span>

                  <button
                    className="btn btn-dark me-2"
                    onClick={() =>
                      changePageDownload(paginationDownload?.current_page + 1)
                    }
                    disabled={
                      paginationDownload?.current_page ===
                      paginationDownload?.last_page
                    }
                  >
                    ›
                  </button>

                  <button
                    className="btn btn-dark"
                    onClick={() =>
                      changePageDownload(paginationDownload?.last_page)
                    }
                    disabled={
                      paginationDownload?.current_page ===
                      paginationDownload?.last_page
                    }
                  >
                    »
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default React.memo(DetailsSection);
